import React, { memo } from 'react';

import MaskedInput from 'react-text-mask';

const InputCpf = (props) => {
  return (
    <MaskedInput
      {...props}
      type="text"
      mask={[
        /[A-z|0-9]/,
        /[A-z|0-9]/,
        /[A-z|0-9]/,
        '.',
        /[A-z|0-9]/,
        /[A-z|0-9]/,
        /[A-z|0-9]/,
        '.',
        /[A-z|0-9]/,
        /[A-z|0-9]/,
        /[A-z|0-9]/,
        '-',
        /[A-z|0-9]/,
        /[A-z|0-9]/,
      ]}
    />
  );
};

export default memo(InputCpf);
